"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = enhance;
/*  weak */
function enhance() {
  for (var _len = arguments.length, enhancers = Array(_len), _key = 0; _key < _len; _key++) {
    enhancers[_key] = arguments[_key];
  }

  return function (createRenderer) {
    return function () {
      return enhancers.reduce(function (renderer, enhancer) {
        return enhancer(renderer);
      }, createRenderer.apply(undefined, arguments));
    };
  };
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/enhance.js
// module id = 446
// module chunks = 0